






















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class RisikoDekubitusSection extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any;
  @Prop({ default: false }) readonly disabled!: boolean;

  form: any = {
    instrumen: "braden",
    persepsi_sensorik: 4,
    kelembapan: 4,
    aktivitas: 4,
    mobilisasi: 4,
    nutrisi: 4,
    gesekan: 3,
    total_skor: 0,
    kategori: "rendah"
  };

  items = [
    {
      key: "persepsi_sensorik",
      label: "Persepsi Sensorik",
      opts: [
        { label: "1 – Terbatas Sepenuhnya", skor: 1 },
        { label: "2 – Sangat Terbatas", skor: 2 },
        { label: "3 – Sedikit Terbatas", skor: 3 },
        { label: "4 – Tidak Ada Gangguan", skor: 4 }
      ]
    },
    {
      key: "kelembapan",
      label: "Kelembapan",
      opts: [
        { label: "1 – Selalu Basah", skor: 1 },
        { label: "2 – Sangat Lembab", skor: 2 },
        { label: "3 – Kadang Lembab", skor: 3 },
        { label: "4 – Jarang Lembab", skor: 4 }
      ]
    },
    {
      key: "aktivitas",
      label: "Aktivitas",
      opts: [
        { label: "1 – Tirah Baring", skor: 1 },
        { label: "2 – Terkurung di Kursi", skor: 2 },
        { label: "3 – Kadang Jalan", skor: 3 },
        { label: "4 – Sering Jalan", skor: 4 }
      ]
    },
    {
      key: "mobilisasi",
      label: "Mobilisasi",
      opts: [
        { label: "1 – Imobilitas Total", skor: 1 },
        { label: "2 – Sangat Terbatas", skor: 2 },
        { label: "3 – Sedikit Terbatas", skor: 3 },
        { label: "4 – Tidak Ada Gangguan", skor: 4 }
      ]
    },
    {
      key: "nutrisi",
      label: "Nutrisi",
      opts: [
        { label: "1 – Sangat Buruk", skor: 1 },
        { label: "2 – Kurang Adekuat", skor: 2 },
        { label: "3 – Adekuat", skor: 3 },
        { label: "4 – Sangat Baik", skor: 4 }
      ]
    },
    {
      key: "gesekan",
      label: "Gesekan / Robekan",
      opts: [
        { label: "1 – Bermasalah", skor: 1 },
        { label: "2 – Potensial Bermasalah", skor: 2 },
        { label: "3 – Tidak Bermasalah", skor: 3 }
      ]
    }
  ];

  get kategoriLabel(): string {
    const map: Record<string, string> = {
      rendah: "RENDAH", sedang: "SEDANG", tinggi: "TINGGI", sangat_tinggi: "SANGAT TINGGI"
    };
    return map[this.form.kategori] || "-";
  }

  get alertType(): string {
    if (this.form.kategori === "sangat_tinggi") return "error";
    if (this.form.kategori === "tinggi") return "error";
    if (this.form.kategori === "sedang") return "warning";
    return "success";
  }

  setValue(key: string, val: number) {
    this.form[key] = val;
    this.recalc();
  }

  recalc() {
    const keys = ["persepsi_sensorik","kelembapan","aktivitas","mobilisasi","nutrisi","gesekan"];
    const total = keys.reduce((sum, k) => sum + Number(this.form[k] || 0), 0);
    this.form.total_skor = total;
    if (total <= 9) this.form.kategori = "sangat_tinggi";
    else if (total <= 12) this.form.kategori = "tinggi";
    else if (total <= 14) this.form.kategori = "sedang";
    else this.form.kategori = "rendah";
  }

  created() {
    if (this.value && typeof this.value === "object") {
      this.form = { ...this.form, ...this.value };
    }
  }


  @Watch("form", { deep: true })
  onFormChange(val: any) { this.$emit("input", { ...val }); }

  syncFromValue(val: any) {
    if (!val) return;
    this.form = { ...this.form, ...val };
    this.recalc();
  }
}
